// extracted by mini-css-extract-plugin
module.exports = {"modal":"incoming-call-modal_modal__34zsD","phone-action":"incoming-call-modal_phone-action__330Ae","make-connection":"incoming-call-modal_make-connection__2kXLK"};